(() => {
  "use strict";

  const $ = window.jQuery;
  if (!$) return;

  $(function () {
    document.addEventListener("touchstart", function () {}, true);

    function safeInt(val, fallback = 0) {
      const n = parseInt(val, 10);
      return Number.isFinite(n) ? n : fallback;
    }

    function getHeaderHeightFallback() {
      const $siteHeader = $(".site-header");
      if ($siteHeader.length) return safeInt($siteHeader.outerHeight(true), 0);

      const $headerTop = $(".header-top");
      if ($headerTop.length) return safeInt($headerTop.outerHeight(true), 0);

      const $header = $("#header");
      if ($header.length) return safeInt($header.outerHeight(true), 0);

      return 0;
    }

    function getHeaderPaddingTopFallback() {
      const $headerTop = $(".header-top");
      if (!$headerTop.length) return 0;
      return safeInt($headerTop.css("padding-top"), 0);
    }

    function getMegaFocusableSelector() {
      return [
        ".dcg-mega a[href]",
        ".dcg-mega button:not([disabled])",
        ".dcg-mega [tabindex]:not([tabindex='-1'])"
      ].join(",");
    }

    function getFirstMegaLink(id) {
      const $wrap = $(`[data-sub-menu-category-id="${id}"]`);
      if (!$wrap.length) return $();

      const $preferred = $wrap.find(".dcg-mega-list-link[href]").first();
      if ($preferred.length) return $preferred;

      return $wrap.find(getMegaFocusableSelector()).first();
    }

    function setMegaLinksTabIndex(id, tabIndexValue) {
      const $wrap = $(`[data-sub-menu-category-id="${id}"]`);
      if (!$wrap.length) return;

      $wrap.find(".dcg-mega a[href], .dcg-mega button").attr("tabindex", String(tabIndexValue));
    }

    const menuState = {
      activeMenuCategory: null,
      activeSubMenuCategory: null,
      subMenuActive: false,
      categoryHoverActive: null,

      get initialMenuPosition() {
        return getHeaderHeightFallback();
      },

      handleMenuItemChange(id) {
        this.subMenuActive = false;
        this.activeMenuCategory = id;
        this.activeSubMenuCategory = id;
      },

      setSubMenuActive(value) {
        this.subMenuActive = value;
      },

      setCategoryHoverActive(id) {
        this.categoryHoverActive = id;
      },

      handleSubMenuLeave() {
        this.subMenuActive = false;
        this.activeSubMenuCategory = null;
      },

      setSubMenuPosition(id) {
        const $trigger = $(`[data-top-menu-category-id="${id}"]`);
        const $panel = $(`[data-sub-menu-category-id="${id}"] > .main-menu__sub-menu`);
        if (!$trigger.length || !$panel.length) return;

        const triggerLeft = $trigger.offset().left;
        const panelLeft = $panel.offset().left;

        if (panelLeft > triggerLeft) {
          $panel.css("margin-left", triggerLeft);
        } else {
          $panel.css("margin-left", "");
        }
      },

      hideAll() {
        this.setCategoryHoverActive(null);

        $(".main-menu__sub-menu-container")
          .addClass("main-menu__sub-menu-container--hidden")
          .attr("aria-hidden", "true")
          .css("top", this.initialMenuPosition);

        $("[data-sub-menu-category-id]").addClass("main-menu__sub-menu-wrapper--hidden");
        $(".main-menu__sub-menu-container").find(".dropdown-item").attr("tabindex", "-1");

        if (this.activeMenuCategory !== null) {
          setMegaLinksTabIndex(this.activeMenuCategory, -1);
        }

        $("[data-top-menu-category-id]").attr("aria-expanded", "false");
      },

      showSubMenuCategory(id) {
        $(".main-menu__sub-menu-container")
          .removeClass("main-menu__sub-menu-container--hidden")
          .attr("aria-hidden", "false");

        $("[data-sub-menu-category-id]").addClass("main-menu__sub-menu-wrapper--hidden");

        this.setSubMenuPosition(id);

        const $wrapper = $(`[data-sub-menu-category-id="${id}"]`);
        $wrapper.removeClass("main-menu__sub-menu-wrapper--hidden");

        $wrapper.find(".dropdown-item").attr("tabindex", "0");
        setMegaLinksTabIndex(id, 0);

        $(`[data-top-menu-category-id="${id}"]`).attr("aria-expanded", "true");
      }
    };

    // ── Bug fix: clicking a top-nav category button navigates to that ──────
    // collection page. Previously the <button> had no click action — only
    // hover opened the mega panel. On desktop the panel opens on hover, so
    // a click clearly signals "take me there".
    $(document).on("click", "[data-top-menu-category-id]", function () {
      const id = $(this).data("top-menu-category-id");
      const data = window.dcgMegaData && window.dcgMegaData[id];
      if (data && data.parent && data.parent.url) {
        window.location.href = data.parent.url;
      }
    });

    // ── Also make the in-panel category heading clickable (it's a <div>) ──
    $(document).on("click", ".dcg-mega-heading", function () {
      const $wrapper = $(this).closest("[data-sub-menu-category-id]");
      if (!$wrapper.length) return;
      const id = $wrapper.data("sub-menu-category-id");
      const data = window.dcgMegaData && window.dcgMegaData[id];
      if (data && data.parent && data.parent.url) {
        window.location.href = data.parent.url;
      }
    });

    // ── Browse column: update on primary-category item hover ────────────────
    //
    // The Liquid renders col 2 server-side showing only the FIRST sub-item.
    // dcgMegaData[menuId].items[] holds every sub-item with its subs[].
    // On mouseenter of any .dcg-mega-list-link we read that data and swap
    // the browse column content, using the is-updating fade CSS already
    // defined in dcg-header-menu.css.
    //
    // data-mega-item-idx  — set by Liquid on each link (0-based index)
    // data-mega-browse    — on the [data-mega-browse] container (= menu id)

    function renderBrowseColumn($browse, menuId, itemIdx) {
      const data = window.dcgMegaData && window.dcgMegaData[menuId];
      if (!data || !data.items) return;

      const item = data.items[itemIdx];
      if (!item) return;

      // Fade out
      $browse.addClass("is-updating");

      setTimeout(function () {
        let html = "";

        // Subheading
        html += `<div class="dcg-mega-subheading dcg-mega-browse__heading">${item.title}</div>`;

        // Shop All link
        html += `<a href="${item.url}" class="dcg-mega-browse__shopall">Shop All ${item.title} &rarr;</a>`;

        // Sub-items list or fallback CTA
        if (item.subs && item.subs.length > 0) {
          html += `<ul class="dcg-mega-browse__list">`;
          item.subs.forEach(function (sub) {
            html += `<li class="dcg-mega-browse__item">
              <a href="${sub.url}" class="dcg-mega-browse__link">${sub.title}</a>
            </li>`;
          });
          html += `</ul>`;
        } else {
          html += `<div class="dcg-mega-browse__empty">
            <a href="${item.url}" class="dcg-mega-browse__cta">Browse ${item.title}</a>
          </div>`;
        }

        $browse.html(html).removeClass("is-updating");
      }, 80); // matches --dcg-duration-fast fade
    }

    // Delegate to the mega panel so it works after panel is shown
    $(document).on(
      "mouseenter focusin",
      ".dcg-mega-list-link",
      function () {
        const $link    = $(this);
        const itemIdx  = parseInt($link.attr("data-mega-item-idx"), 10);
        const $wrapper = $link.closest("[data-sub-menu-category-id]");
        if (!$wrapper.length) return;

        const menuId   = $wrapper.attr("data-sub-menu-category-id");
        const $browse  = $wrapper.find("[data-mega-browse]");
        if (!$browse.length) return;

        // Skip if this item is already displayed
        if ($browse.data("dcg-active-idx") === itemIdx) return;
        $browse.data("dcg-active-idx", itemIdx);

        renderBrowseColumn($browse, Number(menuId), itemIdx);
      }
    );

    // Reset browse column to index 0 when the mega panel opens for a category
    // so it always starts on the first item, not the last-hovered one
    $(document).on("mouseenter", "[data-top-menu-category-id]", function () {
      const id = $(this).data("top-menu-category-id");
      const $wrapper = $(`[data-sub-menu-category-id="${id}"]`);
      const $browse  = $wrapper.find("[data-mega-browse]");
      if ($browse.length) {
        $browse.removeData("dcg-active-idx");
      }
    });

    $(window).on("resize orientationchange", function () {
      window.requestAnimationFrame(syncHeaderVars);
    });

    $(document).on("keydown", function (ev) {
      if (ev.key === "Escape") {
        if (menuState.categoryHoverActive !== null) {
          const id = menuState.activeMenuCategory;
          if (id !== null) {
            $(`[data-top-menu-category-id="${id}"]`).focus();
          }
          menuState.hideAll();
        }
      }
    });

    $(".main-menu__close-sub-menu-button").on("click keydown", function (ev) {
      if (ev.type === "click" || ev.key === "Enter" || ev.key === " ") {
        ev.preventDefault();
        menuState.hideAll();
      }
    });

    $("#top-menu")
      .find(".dropdown-item")
      .on("focus", function () {
        if (!$(this).data("top-menu-category-id")) {
          menuState.hideAll();
        }
      });

    $(document).on("keydown", ".main-menu__sub-menu", function (ev) {
      if (ev.key !== "ArrowUp") return;

      const id = menuState.activeMenuCategory;
      if (id === null) return;

      const $activeWrap = $(`[data-sub-menu-category-id="${id}"]`);
      if (!$activeWrap.length) return;

      const $target = $(ev.target);
      if ($target.closest($activeWrap).length) {
        ev.preventDefault();
        $(`[data-top-menu-category-id="${id}"]`).focus();
      }
    });

    $("[data-top-menu-category-id]")
      .on("focus touchstart mouseenter", function () {
        const $trigger = $(this);
        const id = $trigger.data("top-menu-category-id");

        $trigger.off("keydown.dcgMenu").on("keydown.dcgMenu", function (ev) {
          if (ev.key === "ArrowDown") {
            ev.preventDefault();
            const active = menuState.activeMenuCategory || id;
            const $first = getFirstMegaLink(active);
            if ($first.length) $first.focus();
          }
        });

        menuState.setCategoryHoverActive(id);

        // ── Fast-switch: if the mega panel is already open, swap immediately ──
        // This avoids the race where mouseleave on the previous item calls
        // hideAll() (resetting categoryHoverActive) before the 200ms open-
        // timer for this item fires.
        const menuAlreadyOpen = !$(".main-menu__sub-menu-container").hasClass(
          "main-menu__sub-menu-container--hidden"
        );

        if (menuAlreadyOpen) {
          menuState.handleMenuItemChange(id);
          const paddingTop = getHeaderPaddingTopFallback();
          const triggerTop = safeInt($trigger.position().top, 0);
          const triggerHeight = safeInt($trigger.outerHeight(true), 0);
          $(".main-menu__sub-menu-container").css(
            "top",
            triggerTop + paddingTop + triggerHeight
          );
          menuState.showSubMenuCategory(id);
          return;
        }

        setTimeout(function () {
          if (menuState.categoryHoverActive === id) {
            menuState.handleMenuItemChange(id);

            const paddingTop = getHeaderPaddingTopFallback();
            const triggerTop = safeInt($trigger.position().top, 0);
            const triggerHeight = safeInt($trigger.outerHeight(true), 0);
            const top = triggerTop + paddingTop + triggerHeight;

            $(".main-menu__sub-menu-container").css("top", top);
            menuState.showSubMenuCategory(id);
          }
        }, 200);
      })
      .on("mouseleave", function () {
        // Capture which item is being left. If the user has already entered
        // a different category before this timer fires, skip the hide so the
        // pending show-timer for the new category can complete uninterrupted.
        const leavingId = $(this).data("top-menu-category-id");
        setTimeout(function () {
          if (menuState.categoryHoverActive !== leavingId) return;
          if (!menuState.subMenuActive || menuState.activeMenuCategory !== menuState.activeSubMenuCategory) {
            menuState.hideAll();
          }
        }, 100);
      });

    $("[data-sub-menu-category-id] > .main-menu__sub-menu")
      .on("focus touchstart mouseenter", function () {
        menuState.setSubMenuActive(true);
      })
      .on("mouseleave", function () {
        menuState.handleSubMenuLeave();
        setTimeout(function () {
          if (menuState.activeMenuCategory !== menuState.activeSubMenuCategory) {
            menuState.hideAll();
          }
        }, 300);
      });

    $(document).on("mousedown touchstart", function (evt) {
      const $container = $(".main-menu__sub-menu-container");

      if (!$container.hasClass("main-menu__sub-menu-container--hidden")) {
        const $target = $(evt.target);
        const inside =
          $target.closest(".main-menu__sub-menu-container").length ||
          $target.closest("#top-menu").length;

        if (!inside) {
          menuState.hideAll();
        }
      }
    });

    $(document).on("click", "li.mobile-menu-category > .mobile-menu-category__wrapper", function (e) {
      const $item = $(this).closest("li.mobile-menu-category");
      const hasSubmenu = $item.find("> .mobile-menu-category__submenu").length > 0;

      if (!hasSubmenu) return;

      e.preventDefault();

      if ($item.hasClass("mobile-menu-category__dropdown--closed")) {
        $item
          .siblings("li.mobile-menu-category.mobile-menu-category__dropdown--opened")
          .removeClass("mobile-menu-category__dropdown--opened")
          .addClass("mobile-menu-category__dropdown--closed");

        $item
          .removeClass("mobile-menu-category__dropdown--closed")
          .addClass("mobile-menu-category__dropdown--opened");
      } else {
        $item
          .removeClass("mobile-menu-category__dropdown--opened")
          .addClass("mobile-menu-category__dropdown--closed");
      }
    });

    $(document).on(
      "click",
      "li.mobile-menu-category > .mobile-menu-category__wrapper > .mobile-menu-category__dropdown",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).closest(".mobile-menu-category__wrapper").trigger("click");
      }
    );

    (function initHoverKeepalive() {
      const root = document.documentElement;
      const nav = document.querySelector("#top-menu");
      if (!nav) return;

      const dropdownWrap = document.querySelector(".main-menu__sub-menu-container");
      const closeDelay = 250;
      let closeTimer = null;

      function clearCloseTimer() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      }

      function keepAlive() {
        clearCloseTimer();
      }

      function scheduleClose() {
        clearCloseTimer();
        closeTimer = window.setTimeout(function () {
          root.classList.remove("dcg-menu-hovering");
        }, closeDelay);
      }

      nav.addEventListener("mouseenter", function () {
        keepAlive();
        root.classList.add("dcg-menu-hovering");
      });

      nav.addEventListener("mouseleave", scheduleClose);

      if (dropdownWrap) {
        dropdownWrap.addEventListener("mouseenter", keepAlive);
        dropdownWrap.addEventListener("mouseleave", scheduleClose);
      }
    })();

    const trustbar = document.querySelector(".dcg-trustbar");
    const header = document.querySelector(".dcg-header");
    const root = document.documentElement;

    let lastHeaderTop = null;
    let lastHeaderHeight = null;
    let ticking = false;

    function syncHeaderVars() {
      const scrollY = window.scrollY || window.pageYOffset || 0;
      const trustbarHeight = trustbar ? Math.round(trustbar.offsetHeight) : 0;
      const headerHeight = header ? Math.round(header.offsetHeight) : menuState.initialMenuPosition;
      const headerTop = Math.max(trustbarHeight - scrollY, 0);

      if (headerTop !== lastHeaderTop) {
        root.style.setProperty("--dcg-trustbar-h", `${headerTop}px`);
        lastHeaderTop = headerTop;
      }

      if (headerHeight !== lastHeaderHeight) {
        root.style.setProperty("--dcg-header-h", `${headerHeight}px`);
        lastHeaderHeight = headerHeight;
      }

      ticking = false;
    }

    function requestHeaderSync() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(syncHeaderVars);
      }
    }

    window.addEventListener("scroll", requestHeaderSync, { passive: true });
    window.addEventListener("resize", requestHeaderSync);
    window.addEventListener("load", requestHeaderSync);

    if ("ResizeObserver" in window) {
      const resizeObserver = new ResizeObserver(requestHeaderSync);
      if (header) resizeObserver.observe(header);
      if (trustbar) resizeObserver.observe(trustbar);
    }

    requestHeaderSync();
  });
})();